module.exports = __webpack_public_path__ + "static/media/midwest.8051d11e.png";